import React from "react";
import { useSelector } from "react-redux";
import { PusherChannel } from "@activecollab/activecollab-react-pusher";
import PropTypes from "prop-types";
import { getGlobalPresenceChannelName } from "~/store/selectors/selector.realTime";
import { WhoIsOnline } from "./WhoIsOnline.jsx";

export const Provider = ({ children }) => {
  const channelName = useSelector(getGlobalPresenceChannelName);

  return (
    <PusherChannel name={channelName}>
      <WhoIsOnline>{children}</WhoIsOnline>
    </PusherChannel>
  );
};

Provider.propTypes = {
  children: PropTypes.node,
};

Provider.displayName = "WhoIsOnlineProvider";
